// 国家
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("country") || ""
}

const getters = {
  getCountry:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("country",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("country")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}